module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择日期范围"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "alue-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.vdate),
      callback: function($$v) {
        _vm.vdate = $$v
      },
      expression: "vdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "订单数",
      "name": "order_count"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "order_count",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "付款订单数",
      "name": "order_payed_count"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "order_payed_count",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "交易额",
      "name": "amount_payed_count"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "amount_payed_count",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "GMV",
      "name": "gmv_count"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "gmv_count",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "售后单数",
      "name": "aftersales_count"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "aftersales_count",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "退款额",
      "name": "refunded_count"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "refunded_count",
      "height": "120"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allListData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "count_date",
      "label": "日期",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_count",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_payed_count",
      "label": "付款订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount_payed_count",
      "label": "交易额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.amount_payed_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gmv_count",
      "label": "GMV"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.gmv_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aftersales_count",
      "label": "售后单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "退款额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.refunded_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yx_order_count",
      "label": "优选_订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yx_order_payed_count",
      "label": "优选_付款订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yx_amount_payed_count",
      "label": "优选_交易额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.yx_amount_payed_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yx_gmv_count",
      "label": "优选_GMV"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.yx_gmv_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yx_aftersales_count",
      "label": "优选_售后单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优选_退款额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.yx_refunded_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yaoking_order_count",
      "label": "到家_订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yaoking_order_payed_count",
      "label": "到家_付款订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yaoking_amount_payed_count",
      "label": "到家_交易额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.yaoking_amount_payed_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yaoking_gmv_count",
      "label": "到家_GMV"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.yaoking_gmv_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yaoking_aftersales_count",
      "label": "到家_售后单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "到家_退款额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.yaoking_refunded_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vip_order_count",
      "label": "付费会员_订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vip_order_payed_count",
      "label": "付费会员_付款订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vip_amount_payed_count",
      "label": "付费会员_交易额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.vip_amount_payed_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vip_gmv_count",
      "label": "付费会员_GMV"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.vip_gmv_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "付费会员_退款额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.vip_refunded_count / 100))]
      }
    }])
  })], 1)]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f31f72e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f31f72e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/datacube/companydata/order.vue
// module id = 2655
// module chunks = 0